/**
 * Non-block item ids.
 *
 * Kept in its own module so both `blocks.ts` (block drops can be items, such as
 * coal ore dropping coal) and `items.ts` can share the numbering without a
 * circular import.
 */

/** First id reserved for non-block items. */
export const ITEM_ID_BASE = 64;

export const STICK = ITEM_ID_BASE;

export const WOODEN_PICKAXE = ITEM_ID_BASE + 1;
export const WOODEN_AXE = ITEM_ID_BASE + 2;
export const WOODEN_SHOVEL = ITEM_ID_BASE + 3;
export const STONE_PICKAXE = ITEM_ID_BASE + 4;
export const STONE_AXE = ITEM_ID_BASE + 5;
export const STONE_SHOVEL = ITEM_ID_BASE + 6;

/** Smelting materials. */
export const COAL = ITEM_ID_BASE + 7;
export const CHARCOAL = ITEM_ID_BASE + 8;
export const IRON_INGOT = ITEM_ID_BASE + 9;
export const GOLD_INGOT = ITEM_ID_BASE + 10;

/** Iron tools, smelted from iron ingots. */
export const IRON_PICKAXE = ITEM_ID_BASE + 11;
export const IRON_AXE = ITEM_ID_BASE + 12;
export const IRON_SHOVEL = ITEM_ID_BASE + 13;

/** Passive-animal drops and furnace-cooked food. */
export const RAW_BEEF = ITEM_ID_BASE + 14;
export const COOKED_BEEF = ITEM_ID_BASE + 15;
export const RAW_PORKCHOP = ITEM_ID_BASE + 16;
export const COOKED_PORKCHOP = ITEM_ID_BASE + 17;
export const RAW_MUTTON = ITEM_ID_BASE + 18;
export const COOKED_MUTTON = ITEM_ID_BASE + 19;

/** Diamond ore drops and diamond-tier tools. */
export const DIAMOND = ITEM_ID_BASE + 20;
export const DIAMOND_PICKAXE = ITEM_ID_BASE + 21;
export const DIAMOND_AXE = ITEM_ID_BASE + 22;
export const DIAMOND_SHOVEL = ITEM_ID_BASE + 23;

/** Archery, ranged combat and skeleton drops. */
export const BOW = ITEM_ID_BASE + 24;
export const ARROW = ITEM_ID_BASE + 25;
export const STRING = ITEM_ID_BASE + 26;
export const FEATHER = ITEM_ID_BASE + 27;
export const FLINT = ITEM_ID_BASE + 28;
export const BONE = ITEM_ID_BASE + 29;

/** Swords across all 4 material tiers. */
export const WOODEN_SWORD = ITEM_ID_BASE + 30;
export const STONE_SWORD = ITEM_ID_BASE + 31;
export const IRON_SWORD = ITEM_ID_BASE + 32;
export const DIAMOND_SWORD = ITEM_ID_BASE + 33;

/** Leather material dropped by cows. */
export const LEATHER = ITEM_ID_BASE + 34;

/** Armor items across Leather, Iron and Diamond tiers. */
export const LEATHER_HELMET = ITEM_ID_BASE + 35;
export const LEATHER_CHESTPLATE = ITEM_ID_BASE + 36;
export const LEATHER_LEGGINGS = ITEM_ID_BASE + 37;
export const LEATHER_BOOTS = ITEM_ID_BASE + 38;

export const IRON_HELMET = ITEM_ID_BASE + 39;
export const IRON_CHESTPLATE = ITEM_ID_BASE + 40;
export const IRON_LEGGINGS = ITEM_ID_BASE + 41;
export const IRON_BOOTS = ITEM_ID_BASE + 42;

export const DIAMOND_HELMET = ITEM_ID_BASE + 43;
export const DIAMOND_CHESTPLATE = ITEM_ID_BASE + 44;
export const DIAMOND_LEGGINGS = ITEM_ID_BASE + 45;
export const DIAMOND_BOOTS = ITEM_ID_BASE + 46;

/** Gunpowder dropped by creepers, used to craft TNT. */
export const GUNPOWDER = ITEM_ID_BASE + 47;

/** Spider eye dropped by spiders, edible with food stats. */
export const SPIDER_EYE = ITEM_ID_BASE + 48;
